import { getContentfulService } from '../http/http.factory';
import { Asset, CollectionRequest, AssetCollectionResponse } from './static-assets-api.model';

const getPreviewValue = (): boolean => {
  if (typeof window !== 'undefined') {
    const localStoragePreview = localStorage.getItem('CONTENTFUL_PREVIEW');
    if (localStoragePreview !== null) {
      return localStoragePreview === 'true';
    }
  }
  return process.env.NEXT_PUBLIC_CONTENTFUL_PREVIEW === 'true';
};

const preview = getPreviewValue();

export class StaticAssetsApiService {
  static getAssetsFetcher(tags: string[]) {
    return {
      key: `getAssetsFetcher${tags.join('-')}`,
      fetcher: () => StaticAssetsApiService.getAssetCollection(tags),
    };
  }

  static async getAssetCollection(tags: string[]): Promise<Asset[]> {
    const body: CollectionRequest = {
      query: `query($preview: Boolean, $tags: [String]) {
        assetCollection(
          preview: $preview
          where: { contentfulMetadata: { tags: { id_contains_some: $tags } } }
        ) {
          items {
            title
            fileName
            description
            url
            width
            height,
            contentfulMetadata {
              tags {
                id
              }
            }
          }
        }
      }
            `,
      variables: {
        preview,
        tags,
      },
    };
    return StaticAssetsApiService.makeAssetCollectionsRequest(body);
  }
  private static async makeAssetCollectionsRequest(body: CollectionRequest) {
    const assetsCollectionResponse: AssetCollectionResponse = await getContentfulService().post<any, any>(
      `/spaces/{contentfulSpace}/environments/{contentfulEnv}`,
      body,
      {
        pathParams: {
          contentfulSpace: process.env.NEXT_PUBLIC_CONTENTFUL_SPACE || '',
          contentfulEnv: process.env.NEXT_PUBLIC_CONTENTFUL_ENV || 'master',
        },
      }
    );

    return assetsCollectionResponse.data.assetCollection?.items || [];
  }
}
